module.exports = __webpack_public_path__ + "static/media/p8.a7aa0410.jpg";